import Backbone from 'backbone';
import { EmptyObject } from '@ve/types/EmptyObject';

interface BlockParams {
    block?: true,
}

export default (tourCriteria: Backbone.Model): BlockParams | EmptyObject => {
    const params: BlockParams | EmptyObject = {};
    const element: boolean | null = tourCriteria.get('block');
    if (element) {
        params.block = element;
    }

    return params;
};